import VersionCompareKeyValueGrid from 'components/v2/compiler/version-compare/VersionCompareKeyValueGrid';
import { VersionCompareRow } from 'components/v2/compiler/version-compare/VersionCompareRow';
import { EpdVersionHistoryData } from 'components/v2/compiler/version-history/utils/EpdVersionHistoryDataContext';
import { ImagesUpload } from 'components/v2/images-upload';
import SmartLabel from 'components/v2/labels/SmartLabel';
import React from 'react';
import ComparePanelComponent from '../../../../pages/v2/compiler/ComparePanelComponent';
import SystemBoundaryGridPdf from '../grids/system-boundary/SystemBoundaryGridPdf';
import { getSystemBoundaryGridRows } from '../version-history/content/VersionHistorySystemBoundaryGrid';

const CompareSystemBoundarySection: React.FC<{
  data: { left: EpdVersionHistoryData | null; right: EpdVersionHistoryData | null };
}> = ({ data }) => {
  return (
    <ComparePanelComponent title="System boundary">
      <VersionCompareRow data={data} compareByDom>
        {({ item, compareClassName }) => (
          <SystemBoundaryGridPdf
            className={compareClassName}
            epdVersionId={item!.epdVersionId}
            productType={item!.epdDefinitionInformation.productType}
            dontApplyPrintStyles
          />
        )}
      </VersionCompareRow>

      <VersionCompareRow data={data} displayCondition={(x) => !!x?.systemBoundary}>
        {({ isLeft }) => <VersionCompareKeyValueGrid isLeft={isLeft} rowsGetter={getSystemBoundaryGridRows} />}
      </VersionCompareRow>

      <VersionCompareRow
        data={data}
        displayCondition={(x) => (x?.systemBoundary?.processFlowDiagramsImages || []).length > 0}
        compareBy={(item) => item?.systemBoundary?.processFlowDiagramsImages?.map((x) => x.name).join(',')}
      >
        {({ item, compareClassName }) => (
          <div>
            <SmartLabel label="Process flow diagram(s) related images" />
            <ImagesUpload
              className={compareClassName}
              name="ProcessFlowDiagramsImages"
              images={item?.systemBoundary?.processFlowDiagramsImages || []}
              onUpload={() => {}}
              onReorder={() => {}}
              onRemove={() => {}}
              disabled
              preferEnabledAppearanceEvenWhenDisabled
            />
          </div>
        )}
      </VersionCompareRow>
    </ComparePanelComponent>
  );
};

export default CompareSystemBoundarySection;
